import {addIcons} from "ionicons";

export function registerCustomIcons() {
  addIcons({
    "power-meter": "assets/icons/power-meter.svg",
    "pv-inverter": "assets/icons/pv-inverter.svg",
    "fuse": "assets/icons/fuse.svg",
    "mode-switch": "assets/icons/mode-switch.svg",
    "equals": "assets/icons/equals.svg",
    "season": "assets/icons/season.svg",
    "diagnostic": "assets/icons/diagnostic.svg",
    "plant": "assets/icons/plant.svg",
  });

}
